import React, { useState } from "react";
import { Box } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { useTranslation } from "react-i18next";
import { youtubeEmbedSrc, youtubeThumbnailUrl } from "../../../utils/youtubeEmbed";

const TeamYouTubeEmbed = ({ video, onAccentBubble = false }) => {
  const { t } = useTranslation("team");
  const [playing, setPlaying] = useState(false);
  const [thumbError, setThumbError] = useState(false);

  const videoId = video?.videoId;
  if (!videoId) return null;

  const title = t("youtubeEmbedTitle", "YouTube");
  const playLabel = t("youtubePlayLabel", "Reproduzir vídeo do YouTube");
  const embedSrc = youtubeEmbedSrc({
    videoId,
    startSeconds: video.startSeconds,
    autoplay: playing,
  });
  const thumbSrc = youtubeThumbnailUrl(videoId);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        aspectRatio: "16 / 9",
        borderRadius: 1.5,
        overflow: "hidden",
        bgcolor: "#000",
        border: (th) =>
          onAccentBubble ? `1px solid ${th.palette.common.white}22` : `1px solid ${th.palette.divider}`,
      }}
    >
      {playing ? (
        <Box
          component="iframe"
          src={embedSrc}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            border: 0,
            display: "block",
          }}
        />
      ) : (
        <Box
          component="button"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setPlaying(true);
          }}
          aria-label={playLabel}
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            p: 0,
            border: 0,
            cursor: "pointer",
            bgcolor: "#000",
            display: "block",
            "&:hover img": { opacity: 0.88 },
            "&:hover .yt-play": { transform: "translate(-50%, -50%) scale(1.08)" },
          }}
        >
          {!thumbError && thumbSrc ? (
            <Box
              component="img"
              src={thumbSrc}
              alt=""
              decoding="async"
              loading="lazy"
              onError={() => setThumbError(true)}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
                transition: "opacity 0.15s ease",
              }}
            />
          ) : null}
          <Box
            className="yt-play"
            aria-hidden
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 58,
              height: 58,
              borderRadius: "50%",
              bgcolor: "error.main",
              color: "common.white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
              boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
              transition: "transform 0.15s ease",
            }}
          >
            <PlayArrowRoundedIcon sx={{ fontSize: 36, ml: "2px" }} />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default TeamYouTubeEmbed;
